import { LucideIcon } from 'lucide-react';

const colorClasses = {
  green: {
    border: 'border-l-4 border-[#2E7D32]',
    bg: 'bg-green-50',
    text: 'text-[#2E7D32]',
  },
  amber: {
    border: 'border-l-4 border-[#FFA000]',
    bg: 'bg-amber-50',
    text: 'text-[#FFA000]',
  },
  red: {
    border: 'border-l-4 border-[#D32F2F]',
    bg: 'bg-red-50',
    text: 'text-[#D32F2F]',
  },
  teal: {
    border: 'border-l-4 border-[#0097A7]',
    bg: 'bg-teal-50',
    text: 'text-[#0097A7]',
  },
  gray: {
    border: 'border-l-4 border-gray-400',
    bg: 'bg-gray-50',
    text: 'text-gray-700',
  },
};

export function KPICard({
  title,
  value,
  subtitle,
  icon: Icon,
  color = 'gray',
  bgTint = false,
}) {
  const colors = colorClasses[color];

  return (
    <div className={`bg-white rounded-lg shadow-sm p-4 ${colors.border} ${bgTint ? colors.bg : ''}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-600 mb-1">{title}</p>
          <p className={`text-3xl font-semibold ${colors.text} leading-tight`}>{value}</p>
          {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
        {Icon && (
          <div className={`p-2 rounded-lg flex-shrink-0 ml-2 ${colors.bg}`}>
            <Icon className={`w-5 h-5 ${colors.text}`} />
          </div>
        )}
      </div>
    </div>
  );
}
